import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConnectProto } from "@racoon/api";

type StatsState = {
  serviceProviderStats: ConnectProto.ServiceProviderStats | null;
};

const initialState: StatsState = {
  serviceProviderStats: null,
};

const slice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    setServiceProviderStats(state, action: PayloadAction<ConnectProto.ServiceProviderStats>) {
      state.serviceProviderStats = action.payload;
    },
    clearServiceProviderStats(state) {
      state.serviceProviderStats = null;
    },
  },
});

export const { setServiceProviderStats, clearServiceProviderStats } = slice.actions;
export const statsReducer = slice.reducer;
